import { render, staticRenderFns } from "./visitUndoList.vue?vue&type=template&id=48e5dfbf&scoped=true"
import script from "./visitUndoList.vue?vue&type=script&lang=js"
export * from "./visitUndoList.vue?vue&type=script&lang=js"
import style0 from "./visitUndoList.vue?vue&type=style&index=0&id=48e5dfbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e5dfbf",
  null
  
)

export default component.exports